import { PhysicalExperienceSelection } from 'services/api/entities/events/types/internal/selections'
import { YupSchema } from 'services/yup'
import { optionedProductSelectionVS } from './common/optionedProduct'

export const physicalExperienceSelectionVS: YupSchema<PhysicalExperienceSelection> =
  optionedProductSelectionVS
